import React, { useEffect, useState } from 'react'
import { InfosWrapper, MapInfo, MapsContainer, MapWrapper } from './MapStyles';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import axios from 'axios';

const MapEmbed = () => {
    const adress = 'Matteo Gianella, 176 - Santa Catarina, Caxias';
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyA89abU3EO6hyAwrQvEDvCa79P5M6o_eLc"
    })
    
    // const [map, setMap] = useState(null);
    const [location, setLocation] = useState();
      
    const getLocation = async () => {
        const { data } = await axios("https://maps.googleapis.com/maps/api/geocode/json?address="+ adress +"&key=AIzaSyA89abU3EO6hyAwrQvEDvCa79P5M6o_eLc");
        setLocation(data.results[0].geometry.location);
    };
  
    useEffect(() => {
        getLocation();
    }, []);
  
    
    return isLoaded ? (
        <MapsContainer>
            <MapWrapper>
                <GoogleMap
                    center={location}
                    zoom={18}
                    disableDefaultUI={true}
                    options={
                        {
                            disableDefaultUI: true,
                        }
                    }
                >
                    <Marker position={location} />
                </GoogleMap>
            </MapWrapper>

            <InfosWrapper>
                <MapInfo>
                    <h3>{adress}</h3>
                    <span>
                        <a href="tel:+55 54 35378297">(54) 3537-8297</a>
                    </span>
                    &nbsp; | &nbsp;
                    <span>
                    <a href="https://api.whatsapp.com/message/PBDXCR3XANWVC1?autoload=1&amp;app_absent=0" target="_blank" rel="noopener noreferrer">(54) 9 9255-3402</a>
                    </span>
                </MapInfo>

                <MapInfo>
                    <h3>Seg. a Sex.</h3>
                    <span>08h as 20h</span>
                </MapInfo>

                <MapInfo>
                    <h3>Sábado</h3>
                    <span>08h as 19h</span>
                </MapInfo>

                <MapInfo>
                    <h3>Domingo</h3>
                    <span>14h as 19h</span>
                </MapInfo>
            </InfosWrapper>
        </MapsContainer>
    ) : <></>
}

export default React.memo(MapEmbed);